import { useQuery } from "@tanstack/react-query";
import { campaignService } from "../campaignService";
import type { CampaignAvailability } from "../campaignTypes";

const DEFAULT_AVAILABILITY: CampaignAvailability = {
  enabled: false,
  companyIds: [],
};

/**
 * Diz se a feature "Campanha" está liberada para o grupo do usuário e para
 * quais lojas (flag `campaign` + COMPANY_ALLOWLIST no backend).
 *
 * Enquanto carrega vale `{ enabled: false, companyIds: [] }` — o padrão
 * seguro é não piscar um menu/rota inteira que a empresa talvez não tenha.
 * O gate de verdade é o do backend, que responde 403 nas ações.
 */
export const useCampaignAvailability = () => {
  const { data, isPending } = useQuery({
    queryKey: ["campaign-availability"],
    queryFn: campaignService.getAvailability,
    // A flag muda por toggle manual no BackOffice, não durante o uso:
    // uma busca por sessão de aba basta.
    staleTime: Infinity,
    // Uma tentativa extra: a falha aqui esconde o menu inteiro e derruba o
    // usuário de volta pro Dashboard, então um blip de rede não deveria
    // decidir isso sozinho. Continua fail-closed depois do retry.
    retry: 1,
  });

  return {
    availability: data ?? DEFAULT_AVAILABILITY,
    isLoadingAvailability: isPending,
  };
};
